import { TriangleAlert } from 'lucide-react';

export const MaintenanceBanner = () => {
  const showMaintenanceBanner =
    import.meta.env.VITE_SHOW_MAINTENANCE_BANNER === 'true';

  const maintenanceBannerDateRange =
    import.meta.env.VITE_SHOW_MAINTENANCE_BANNER_DATE_RANGE ??
    'Thursday December 4 between 9pm ET and 10pm ET';

  if (!showMaintenanceBanner) return null;

  return (
    <div className="border border-yellow-400 bg-yellow-100 p-4">
      <div className="flex gap-4">
        <div className="flex-shrink-0">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-300">
            <TriangleAlert className="text-yellow-800" size={24} />
          </div>
        </div>
        <div className="flex-1">
          <p className="font-bold text-yellow-800">
            Scheduled Maintenance Notice
          </p>
          <p className="mt-1 text-[14px] text-yellow-800">
            We&apos;ll be performing planned maintenance on{' '}
            <strong>{maintenanceBannerDateRange}</strong>.
          </p>
          <p className="mt-1 text-[14px] text-yellow-800">
            During this window, some features may be slow or temporarily
            unavailable. We appreciate your understanding and apologize for any
            inconvenience.
          </p>
        </div>
      </div>
    </div>
  );
};
